(() => {
  const racine = document.getElementById('nvw');
  if (!racine || racine.dataset.pret) return;
  racine.dataset.pret = '1';

  const vues = [...racine.querySelectorAll('.nvw__vue')];
  const vignettes = [...racine.querySelectorAll('.nvw__vignette')];
  const scene = racine.querySelector('.nvw__scene');
  const bandeau = racine.querySelector('.nvw__vignettes');
  let pos = 0;

  const afficher = (n) => {
    if (!vues.length) return;
    pos = (n + vues.length) % vues.length;
    vues.forEach((v, i) => v.classList.toggle('nvw__vue--on', i === pos));
    vignettes.forEach((v, i) => v.classList.toggle('nvw__vignette--on', i === pos));
  };

  if (scene) {
    scene.addEventListener('click', (e) => {
      const f = e.target.closest('.nvw__fleche');
      if (f) afficher(pos + Number(f.dataset.pas));
    });
    let depart = null;
    scene.addEventListener('touchstart', (e) => { depart = e.touches[0].clientX; }, { passive: true });
    scene.addEventListener('touchend', (e) => {
      if (depart === null) return;
      const ecart = e.changedTouches[0].clientX - depart;
      if (Math.abs(ecart) > 36) afficher(ecart < 0 ? pos + 1 : pos - 1);
      depart = null;
    }, { passive: true });
  }

  if (bandeau) {
    bandeau.addEventListener('click', (e) => {
      const v = e.target.closest('.nvw__vignette');
      if (v) afficher(Number(v.dataset.i));
    });
  }

  const offres = racine.querySelector('.nvw__offres');
  const cibles = {
    p: racine.querySelector('.nvw__prix'),
    b: racine.querySelector('.nvw__barre'),
    r: racine.querySelector('.nvw__remise')
  };
  const ctaPrix = racine.querySelector('.nvw__cta-prix');

  const refleter = (radio) => {
    if (!radio) return;
    Object.keys(cibles).forEach((cle) => {
      if (cibles[cle]) cibles[cle].textContent = radio.dataset[cle];
    });
    if (ctaPrix) ctaPrix.textContent = ' · ' + radio.dataset.p;
  };

  if (offres) {
    offres.addEventListener('change', (e) => {
      if (e.target.matches('input[name="id"]') && e.target.checked) refleter(e.target);
    });
    refleter(offres.querySelector('input[name="id"]:checked'));
  }
})();
